import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { FormHelperText, Checkbox, makeStyles, Tooltip, FormLabel, Button, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import FunctionsIcon from "@material-ui/icons/Functions";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { identityRecordOfFieldEditorOptions, getFieldError } from "./utils";
import clsx from "clsx";
const checkboxVariants = [
    "standard",
    "chevron",
    "star",
    "functions",
    "calculator",
    "button"
];
const colors = ["primary", "secondary", "default"];
const useStyles = makeStyles(theme => ({
    root: {
        width: "fit-content"
    },
    control: {},
    checkbox: {},
    innerLabel: {},
    formControlLabel: {}
}), { name: "CheckboxField" });
export const useFieldToCheckbox = (props) => {
    const { field, form, disabled, errorDisplay, onChange, ...rest } = props;
    const { value } = field;
    const { errors, touched, isSubmitting, setFieldValue } = form;
    // "1" / "0" -> true / false
    const checked = value === "1" || value === 1 || value === "checked" || value === true;
    const onChangeFunc = useCallback((e, checked) => {
        e.target.value = checked;
        if (onChange)
            onChange(e, checked);
        else
            setFieldValue(field.name, checked);
    }, [field.name, onChange, setFieldValue]);
    return {
        disabled: disabled != null ? disabled : isSubmitting,
        ...rest,
        ...field,
        ...getFieldError(errors, touched, field.name, errorDisplay),
        checked,
        value: checked ? "checked" : "",
        onChange: onChangeFunc
    };
};
const colorRemapper = (c) => (c === "default" ? "inherit" : c);
export function CheckboxWithLabelField(props) {
    const { items, getItemValue, getItemLabel, valueKey, labelKey, getItemSuggestions, onSelectItem, options, manual, horizontal, multiple, pending, emptyEqualsZero, formatString, onKeyPress, italicText, boldText, label, modalText, textAlign, clearable, literal, ...rest } = props;
    const checkboxProps = useFieldToCheckbox(rest);
    const hasLabel = typeof label === "string" ? label.trim() !== "" : Boolean(label);
    return (_jsx(DployCheckboxWithLabelField, { tooltipTitle: hasLabel ? undefined : options?.buttonText, ...checkboxProps, label: hasLabel ? label : undefined }));
}
function DployCheckboxWithLabelFieldInternal(props) {
    const { label, helperText, error, fullWidth, classes, disabled, variant, color: _, className, tooltipTitle, ...checkboxProps } = props;
    const internalClasses = useStyles();
    let color = props.color;
    let icon = undefined;
    let checkedIcon = undefined;
    switch (variant) {
        case "chevron":
            icon = (_jsx(KeyboardArrowDownIcon, { color: colorRemapper(color) || "primary" }));
            checkedIcon = (_jsx(KeyboardArrowUpIcon, { color: colorRemapper(color) || "primary" }));
            color = undefined;
            break;
        case "star":
            icon = _jsx(StarBorderIcon, {});
            checkedIcon = _jsx(StarIcon, {});
            break;
        case "functions":
            icon = _jsx(FunctionsIcon, {});
            checkedIcon = _jsx(FunctionsIcon, {});
            break;
        case "calculator":
            icon = (_jsx("i", { className: "fa fa-calculator", style: { fontSize: "1.5rem" } }));
            break;
        case "button":
            break;
    }
    const selected = Boolean(checkboxProps.value);
    const controlElement = variant === "button" || variant === "calculator" ? (_jsx(Button, { size: "large", color: color, "data-option-label": label, "data-option-value": "checked", variant: variant === "calculator"
            ? "text"
            : selected
                ? "outlined"
                : "contained", onClick: () => {
            const checked = !selected;
            checkboxProps.onChange?.({
                target: {
                    value: checked ? "checked" : "",
                    checked,
                    name: checkboxProps.name,
                    id: checkboxProps.id
                }
            }, checked);
        }, children: icon ?? label ?? tooltipTitle })) : label ? (_jsx(FormControlLabel, { control: _jsx(Checkbox, { className: internalClasses.checkbox, color: color, icon: icon, checkedIcon: checkedIcon }), label: _jsx(Typography, { className: internalClasses.innerLabel, children: label }), disabled: disabled, className: internalClasses.formControlLabel, ...checkboxProps })) : (_jsx(Checkbox, { ...checkboxProps, className: internalClasses.checkbox, color: color, icon: icon, checkedIcon: checkedIcon, disabled: disabled }));
    return (_jsxs(FormControl, { variant: "standard", className: clsx(className, internalClasses.control), component: "fieldset", error: error, disabled: disabled, fullWidth: fullWidth, classes: { ...classes, root: internalClasses.root }, children: [label && _jsx(FormLabel, { children: "\u00A0" }), tooltipTitle ? (_jsx(Tooltip, { title: tooltipTitle, children: controlElement })) : (controlElement), helperText && _jsx(FormHelperText, { children: helperText })] }));
}
DployCheckboxWithLabelFieldInternal.displayName = "DployCheckboxWithLabelField";
export const DployCheckboxWithLabelField = memo(DployCheckboxWithLabelFieldInternal);
export const EditorCheckboxFields = identityRecordOfFieldEditorOptions({
    CheckboxWithLabelField: {
        editableOptions: {
            variant: checkboxVariants,
            color: colors
        }
    }
});
//# sourceMappingURL=CheckboxField.js.map